import { Button, Form, InputNumber } from 'antd';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import TransparentButton from '@/atoms/button-transparent';
import { useGetPriceRangeData, useGetStaticFilters } from '@core/offices/actions/properties/filterActions';

const PriceRangeMenuContent = ({ menu, handleSubmit }) => {
  const { t } = useTranslation();
  const staticFilters = useGetStaticFilters();
  const { min, max } = useGetPriceRangeData();
  const minValue = parseInt(staticFilters.priceRange?.split('-')[0], 10);
  const maxValue = parseInt(staticFilters.priceRange?.split('-')[1], 10);

  return (
    <>
      <div className="overflow-auto max-h-52">{menu}</div>
      <div className="w-full border-b-[1px] border-solid border-gray-200 my-2" />
      <div className="flex flex-row justify-between items-center gap-2">
        <Form.Item
          rules={[
            {
              type: 'number',
              min,
            },
          ]}
          label={t('filters.minimum')}
          initialValue={Math.max(min, minValue)}
        >
          <InputNumber
            placeholder={t('filters.minPlaceholder')}
            min={min}
            className="w-full rounded-3xl"
            prefixCls="bg-transparent"
            value={Math.max(min, minValue)}
            type="number"
            onChange={(e) => handleSubmit({ ...staticFilters, priceRange: `${e ?? min}-${maxValue || max}` })}
          />
        </Form.Item>
        <Form.Item
          rules={[
            {
              type: 'number',
              max,
            },
          ]}
          label={t('filters.maximum')}
          initialValue={Math.min(max, maxValue)}
        >
          <InputNumber
            placeholder={t('filters.maxPlaceholder')}
            max={max}
            className="w-full rounded-3xl"
            prefixCls="bg-transparent"
            value={Math.min(max, maxValue)}
            type="number"
            onChange={(e) => handleSubmit({ ...staticFilters, priceRange: `${minValue || min}-${e ?? max}` })}
          />
        </Form.Item>
      </div>
      <div className="flex flex-row justify-between gap-2">
        <div className="mb-2 cursor-pointer md:mb-0 w-full">
          <TransparentButton
            className="w-full !cursor-pointer h-11 text-start border-0 font-bold text-gray-500"
            onClick={() => handleSubmit({ ...staticFilters, priceRange: `` })}
          >
            {t('filters.reset')}
          </TransparentButton>
        </div>
        <div className="mb-2 md:mb-0 w-full me-0 md:me-2">
          <Button
            onClick={() => handleSubmit({ ...staticFilters, priceRange: `${minValue}-${maxValue}` })}
            className="w-full h-11 hover:!text-black bg-secondary text-black font-bold"
            htmlType="submit"
          >
            {t('common.apply')}
          </Button>
        </div>
      </div>
    </>
  );
};
export default memo(PriceRangeMenuContent);
